import { motion } from 'framer-motion';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import { TabsContext } from './TabsContext';

export default function Tab(props) {
    const { children, value, className } = props;
    const { activeTab, setActiveTab, disabledTransition, variant } = useContext(TabsContext);

    const handleClick = (event) => {
        const target = event.currentTarget;
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }

        setActiveTab(value);
    };

    const isSelected = activeTab === value;
    const isSolid = variant === 'solid';

    return (
        <button
            type="button"
            role="tab"
            aria-selected={isSelected}
            onClick={handleClick}
            className={cn(
                'flex items-center justify-center h-full w-full text-sm relative whitespace-nowrap',
                isSolid && 'px-3 rounded transition-colors',
                isSolid && (isSelected ? 'bg-dark-blue text-white font-medium' : 'text-gray-600 hover:text-dark-blue'),
                !isSolid && 'px-6',
                !isSolid && (isSelected ? 'font-semibold text-dark-blue' : 'text-dark-blue/50'),
            )}
        >
            {isSelected && !isSolid && (
                <motion.span
                    layoutId={disabledTransition ? undefined : 'tab-bubble'}
                    className="absolute inset-0 bg-white rounded-sm shadow-md"
                    style={{ originY: '0px' }}
                    transition={
                        disabledTransition
                            ? { duration: 0 }
                            : {
                                  type: 'spring',
                                  bounce: 0.2,
                                  duration: 0.4,
                                  layout: { type: 'spring', bounce: 0.2, duration: 0.4, y: { duration: 0 } },
                              }
                    }
                />
            )}

            <div className={cn('relative', className)}>
                <div className="absolute inset-0 z-10 text-center">{children}</div>
                <div
                    className={cn('text-center invisible', isSolid ? 'font-medium' : 'font-semibold')}
                    aria-hidden="true"
                >
                    {children}
                </div>
            </div>
        </button>
    );
}

Tab.propTypes = {
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
};
